// import useSWR from 'swr';
import useSWR from 'swr';
import { REFRESH_INTERVAL_CHAT_QUEUE } from '../../../constants/swr-config';
import { customSWRConfig, customSWRResponse } from '../../../model/types';
import endPoints from '../../../services/endpoints';
import useSWRCacheKeys from '../../useSWRCacheKeys';

export default function useChatQueueCount(config: customSWRConfig = {}): customSWRResponse<number> {
    const keys = useSWRCacheKeys(endPoints.chat.recentChatQueue);
    return useSWR<number>(config['requestFlag'] ? keys : null, {
        ...config,
        refreshInterval: REFRESH_INTERVAL_CHAT_QUEUE
    });
}
